/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Challventure: Zugriff auf den Theme-Cart-Store (ES-Modul) f\u00fcr eigene Skripte
(function () {
  try {
    var s = document.createElement('script');
    s.type = 'module';
    s.textContent = 'import Cart from "cart-store"; window.CV_CART = Cart; document.dispatchEvent(new CustomEvent("cv:cart-ready"));';
    document.head.appendChild(s);
  } catch (e) {}
})();

// Challventure: Hero-CTA scrollt sanft zum Newsletter-Signup
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.home-carousel__btn') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i === -1) return;
    var id = href.slice(i + 1);
    var target = id ? document.getElementById(id) : null;
    if (!target) {
      var form = document.querySelector('#newsletter');
      if (form) target = form.closest('[id^="shopify-section"]') || form;
    }
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

// Challventure: Hinweisbox bei Auswahl "Damen" (Option Schnitt/Passform)
// Nur Bib Shorts + Base Layer – Jersey-Damen ist seit 11.08. bestellbar.
(function () {
  var ONLY_ON = [
    'challventure-bib-shorts-founding-drop-01',
    'challventure-base-layer-founding-drop-01'
  ];
  var aufSeite = ONLY_ON.some(function (h) {
    return window.location.pathname.indexOf('/products/' + h) !== -1;
  });
  if (!aufSeite) return;

  var MSG = 'Der Damen-Schnitt ist noch in Arbeit \u2013 er wird in K\u00fcrze verf\u00fcgbar sein.';

  function findDamenControl() {
    var els = document.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if ((el.value || '').trim().toLowerCase() !== 'damen') continue;
      if (el.closest('#cv-kit-upsell')) continue;
      if (el.closest('form[action*="/cart/add"], variant-picker, [data-product-form], .product-single, .product')) {
        return el;
      }
    }
    return null;
  }

  function update() {
    var el = findDamenControl();
    var box = document.getElementById('cv-damen-notice');
    if (el) {
      if (!box) {
        box = document.createElement('div');
        box.id = 'cv-damen-notice';
        box.style.cssText = 'margin:12px 0;padding:12px 16px;background:#CDE92D;color:#111111;border-radius:10px;font-size:14px;line-height:1.5;';
        box.textContent = MSG;
      }
      var anchor = el.closest('fieldset') || el.closest('[class*="option"]') || el.parentElement;
      if (anchor && anchor.nextElementSibling !== box) {
        anchor.insertAdjacentElement('afterend', box);
      }
      box.style.display = 'block';
    } else if (box) {
      box.style.display = 'none';
    }
  }

  document.addEventListener('change', function () { setTimeout(update, 60); });
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
})();

// Challventure: "Mach dein Kit komplett" Upsell-Box auf allen Kit-PDPs
(function () {
  var JERSEY = 'challventure-jersey-founding-drop-01';
  var BIB = 'challventure-bib-shorts-founding-drop-01';
  var HELM = 'abus-gamechanger-2-0-signal-yellow';

  var BENEFITS = {};
  BENEFITS[JERSEY] = 'Das Trikot, das Basti f\u00e4hrt';
  BENEFITS[BIB] = 'F\u00fcr lange Distanzen entwickelt';
  BENEFITS[HELM] = 'Perfekt zu den Lime-Akzenten des Kits';

  var PAGES = {};
  PAGES[JERSEY] = {
    subline: 'Passend zu deinem Jersey kuratiert.',
    items: [
      { handle: BIB, sizePicker: true, autoSync: true },
      { handle: HELM, sizePicker: true }
    ]
  };
  PAGES[BIB] = {
    subline: 'Passend zu deinen Bib Shorts kuratiert.',
    items: [
      { handle: JERSEY, sizePicker: true, autoSync: true },
      { handle: HELM, sizePicker: true }
    ]
  };
  PAGES[HELM] = {
    subline: 'Passend zu deinem Helm kuratiert.',
    items: [
      { handle: JERSEY, sizePicker: true },
      { handle: BIB, sizePicker: true }
    ]
  };

  var CONFIG = {
    eyebrow: 'Founding Drop Empfehlung',
    heading: 'Mach dein Kit komplett'
  };

  var path = window.location.pathname;
  var page = null;
  Object.keys(PAGES).forEach(function (h) {
    if (path.indexOf('/products/' + h) !== -1) page = PAGES[h];
  });
  if (!page) return;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function getSelectedOptions() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var scope = form ? (form.closest('.product, .product-single, main') || document) : document;
    var values = [];
    scope.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (r.closest('#cv-kit-upsell')) return;
      if (r.closest('form[action*="/cart/add"], variant-picker, [data-product-form], .product-single, .product')) {
        values.push((r.value || '').trim());
      }
    });
    scope.querySelectorAll('variant-picker select, form[action*="/cart/add"] select').forEach(function (s) {
      if (s.name !== 'id' && s.value && !s.closest('#cv-kit-upsell')) values.push((s.value || '').trim());
    });
    return values;
  }

  function findVariant(product, selected) {
    var lower = selected.map(function (v) { return v.toLowerCase(); });
    var match = null;
    product.variants.forEach(function (v) {
      var opts = v.options.map(function (o) { return (o || '').toLowerCase(); });
      var ok = opts.every(function (o) { return lower.indexOf(o) !== -1; });
      if (ok && !match) match = v;
    });
    return match;
  }

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count, .c-header__cart-count, .js-cart-count, cart-link items-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.remove('hidden', 'is-hidden');
      });
    }).catch(function () {});
  }

  function openCartDrawer() {
    var dlg = document.querySelector('.modal--cart, .popup--cart-notification');
    if (!dlg) return false;
    try {
      if (typeof dlg.open === 'function') { dlg.open(); return true; }
      if (typeof dlg.show === 'function') { dlg.show(); return true; }
    } catch (e) {}
    return false;
  }

  function showToast(title) {
    var old = document.getElementById('cv-cart-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.id = 'cv-cart-toast';
    t.style.cssText = 'position:fixed;z-index:99999;right:18px;bottom:18px;max-width:320px;display:flex;align-items:center;gap:12px;padding:14px 16px;background:#10141a;color:#fff;border-radius:12px;box-shadow:0 8px 30px rgba(16,20,26,.28);font-size:14px;line-height:1.4;font-family:inherit;';
    var txt = document.createElement('span');
    txt.style.cssText = 'flex:1 1 auto;';
    txt.innerHTML = '<strong style="color:#CDE92D">\u2713</strong> ' + title + ' liegt im Warenkorb.';
    var link = document.createElement('a');
    link.href = '/cart';
    link.textContent = 'Ansehen';
    link.style.cssText = 'flex:0 0 auto;background:#CDE92D;color:#10141a;text-decoration:none;font-weight:800;font-size:12.5px;padding:8px 12px;border-radius:999px;white-space:nowrap;';
    t.appendChild(txt);
    t.appendChild(link);
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 6000);
  }

  function postAdd(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function addToCart(id) {
    if (window.CV_CART && typeof window.CV_CART.add === 'function') {
      return window.CV_CART.add({ id: id, quantity: 1 });
    }
    return postAdd({ id: id, quantity: 1 }).then(function (res) {
      if (window.CV_CART && typeof window.CV_CART.refresh === 'function') {
        return window.CV_CART.refresh().then(function () { return res; });
      }
      return res;
    });
  }

  function flashSuccess(btn, doneText, normalText, colors) {
    btn.textContent = doneText;
    btn.style.background = colors.doneBg;
    btn.style.borderColor = colors.doneBorder;
    btn.style.color = colors.doneColor;
    updateCartCount();
    setTimeout(function () {
      btn.disabled = false;
      btn.textContent = normalText;
      btn.style.background = colors.bg;
      btn.style.borderColor = colors.border;
      btn.style.color = colors.color;
    }, 2500);
  }

  var rowRefs = [];

  function buildRow(item, product) {
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:flex-start;gap:12px;padding:12px 0;';

    var url = '/products/' + item.handle;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var title = product.title;
    var benefit = BENEFITS[item.handle] || '';

    var a = document.createElement('a');
    a.href = url;
    a.style.cssText = 'flex:0 0 80px;width:80px;height:80px;border-radius:10px;overflow:hidden;background:#f4f4f1;display:block;';
    if (img) {
      var im = document.createElement('img');
      im.src = img.indexOf('//') === 0 ? 'https:' + img : img;
      im.alt = title;
      im.loading = 'lazy';
      im.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      a.appendChild(im);
    }
    row.appendChild(a);

    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;min-width:0;';
    var t = document.createElement('a');
    t.href = url;
    t.textContent = title;
    t.style.cssText = 'display:block;font-size:14.5px;font-weight:700;color:#10141a;text-decoration:none;line-height:1.3;';
    body.appendChild(t);
    if (benefit) {
      var b = document.createElement('div');
      b.textContent = benefit;
      b.style.cssText = 'font-size:12.5px;color:#8f98a1;margin-top:2px;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
      body.appendChild(b);
    }
    var p = document.createElement('div');
    p.textContent = money(product.price);
    p.style.cssText = 'font-size:13.5px;font-weight:700;color:#10141a;margin-top:3px;';
    body.appendChild(p);

    var controls = document.createElement('div');
    controls.style.cssText = 'display:flex;align-items:center;gap:8px;margin-top:8px;flex-wrap:wrap;';

    var sizeSelect = null;
    if (item.sizePicker) {
      sizeSelect = document.createElement('select');
      sizeSelect.setAttribute('aria-label', 'Gr\u00f6\u00dfe w\u00e4hlen');
      sizeSelect.style.cssText = 'flex:0 0 auto;max-width:130px;border:1.5px solid #d8d8d3;background:#fff;color:#10141a;border-radius:999px;padding:6px 10px;font-size:12.5px;font-weight:700;font-family:inherit;cursor:pointer;';
      product.variants.forEach(function (v) {
        if (v.available === false) return;
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        sizeSelect.appendChild(opt);
      });
      if (!sizeSelect.options.length) sizeSelect = null;
      if (sizeSelect) {
        controls.appendChild(sizeSelect);
        if (item.autoSync) {
          var touched = false;
          sizeSelect.addEventListener('change', function () { touched = true; });
          var sync = function () {
            if (touched) return;
            var variant = findVariant(product, getSelectedOptions());
            if (variant && variant.available !== false) {
              var has = Array.prototype.some.call(sizeSelect.options, function (o) { return o.value === String(variant.id); });
              if (has) sizeSelect.value = String(variant.id);
            }
          };
          rowRefs.syncers = rowRefs.syncers || [];
          rowRefs.syncers.push(sync);
          sync();
        }
      }
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Einzeln hinzuf\u00fcgen';
    btn.style.cssText = 'flex:0 0 auto;border:1.5px solid #10141a;background:#fff;color:#10141a;border-radius:999px;padding:7px 14px;font-size:12.5px;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;';
    btn.addEventListener('click', function () {
      var id = sizeSelect ? parseInt(sizeSelect.value, 10) : null;
      if (!id) {
        var variant = findVariant(product, getSelectedOptions());
        if (variant && variant.available !== false) {
          id = variant.id;
        } else {
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available !== false) { id = product.variants[i].id; break; }
          }
        }
      }
      if (!id) { window.location.href = url; return; }
      btn.disabled = true;
      btn.textContent = '\u2026';
      addToCart(id).then(function () {
        flashSuccess(btn, '\u2713 Hinzugef\u00fcgt', 'Einzeln hinzuf\u00fcgen', { doneBg: '#CDE92D', doneBorder: '#CDE92D', doneColor: '#10141a', bg: '#fff', border: '#10141a', color: '#10141a' });
        setTimeout(function () {
          if (!openCartDrawer()) showToast(title);
        }, 120);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Einzeln hinzuf\u00fcgen';
        window.location.href = url;
      });
    });
    controls.appendChild(btn);
    body.appendChild(controls);
    row.appendChild(body);

    rowRefs.push({ item: item, product: product, sizeSelect: sizeSelect });
    return row;
  }

  function insertBox(rows) {
    if (document.getElementById('cv-kit-upsell')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var box = document.createElement('div');
    box.id = 'cv-kit-upsell';
    box.style.cssText = 'margin:16px 0;padding:16px 18px;border:1px solid #eeeeea;border-radius:14px;background:#fff;box-shadow:0 2px 10px rgba(16,20,26,.04);';

    var eyebrow = document.createElement('div');
    eyebrow.style.cssText = 'display:flex;align-items:center;gap:6px;font-size:12px;font-weight:700;color:#6b7280;';
    eyebrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#CDE92D" aria-hidden="true"><path d="M12 2.5l2.6 6.2 6.7.5-5.1 4.4 1.6 6.5-5.8-3.6-5.8 3.6 1.6-6.5-5.1-4.4 6.7-.5z"/></svg>';
    var eyeText = document.createElement('span');
    eyeText.textContent = CONFIG.eyebrow;
    eyebrow.appendChild(eyeText);
    box.appendChild(eyebrow);

    var h = document.createElement('div');
    h.textContent = CONFIG.heading;
    h.style.cssText = 'font-size:18px;font-weight:800;color:#10141a;margin-top:4px;';
    box.appendChild(h);

    var s = document.createElement('div');
    s.textContent = page.subline;
    s.style.cssText = 'font-size:12.5px;color:#8f98a1;margin:2px 0 4px;';
    box.appendChild(s);

    rows.forEach(function (r, i) {
      if (i > 0) r.style.borderTop = '1px solid #f0f0ec';
      box.appendChild(r);
    });

    form.insertAdjacentElement('beforebegin', box);
  }

  function init() {
    var jobs = page.items.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { return buildRow(item, product); })
        .catch(function () { return null; });
    });
    Promise.all(jobs).then(function (rows) {
      rows = rows.filter(Boolean);
      if (rows.length) insertBox(rows);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('#cv-kit-upsell')) return;
      setTimeout(function () {
        (rowRefs.syncers || []).forEach(function (fn) { fn(); });
      }, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Challventure: Produktgalerie beim Scrollen mitlaufen lassen (sticky, nur Desktop)
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var mediaCol = null;
  var mq = window.matchMedia('(min-width: 900px)');

  function findMediaCol() {
    if (mediaCol) return mediaCol;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var node = form;
    var guard = 0;
    while (node && node.parentElement && node.parentElement !== document.body && guard < 12) {
      guard++;
      var parent = node.parentElement;
      var kids = Array.prototype.slice.call(parent.children);
      if (kids.length > 1) {
        for (var i = 0; i < kids.length; i++) {
          var c = kids[i];
          if (c === node || c.contains(form)) continue;
          if (c.id === 'cv-kit-upsell' || (c.querySelector && c.querySelector('#cv-kit-upsell'))) continue;
          var rect = c.getBoundingClientRect();
          if (c.querySelector && c.querySelector('img') && rect.width > 250 && rect.height > 350) {
            mediaCol = c;
            return mediaCol;
          }
        }
      }
      node = parent;
    }
    return null;
  }

  function apply() {
    var col = findMediaCol();
    if (!col) return;
    if (mq.matches) {
      col.style.position = 'sticky';
      col.style.top = '84px';
      col.style.alignSelf = 'flex-start';
    } else {
      col.style.position = '';
      col.style.top = '';
      col.style.alignSelf = '';
    }
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(apply, 300); });
  } else {
    setTimeout(apply, 300);
  }
  window.addEventListener('load', function () { setTimeout(apply, 300); });
})();

// Challventure: Size Finder "Finde deine Groesse"
// HERREN-Schnitt: Jersey + Base Layer (Brustumfang) und seit 19.08. wieder
// BIB SHORTS (Taille). Formel kalibriert an Basti (184 cm / 80 kg):
//   Brust ~96,5 cm -> M; Taille = Brust - 13 -> ~83,5 cm -> M.
// WICHTIG (19.08.): Der alte Bib-Fehler war der doppelte Gewichts-Term
// (Brust->Taille + BMI-Zuschlag) – der ist raus. Die Bib-Taillen-Tabelle
// stammt von der Groessentabellen-Seite (160901824858); eine bestaetigte
// Hersteller-Masstabelle liegt weiterhin NICHT vor – bei Erhalt (QIMA
// measurement.xlsx / Amy) nur HERREN_WAIST unten austauschen.
// DAMEN bleibt ausgenommen (11.08.): kein Kalibrierungspunkt, Damen-Werte aus
// Kleidungsmassen abgeleitet. Bei gewaehltem Damen-Schnitt zeigt das Modal
// keine Empfehlung, sondern den Verweis auf die Masstabelle.
(function () {
  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var HERREN_SIZES = ['S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var HERREN_CHEST = [[88, 94], [94, 98], [98, 102], [102, 106], [106, 111], [111, 116]];
  var HERREN_WAIST = [[76, 81], [81, 86], [86, 91], [91, 96], [96, 101], [101, 106]];
  var PRODUCTS = {
    'challventure-jersey-founding-drop-01': {
      chartUrl: '/pages/groessentabelle-jersey',
      chart: HERREN_CHEST,
      measure: 'chest',
      hatDamen: true
    },
    'challventure-base-layer-founding-drop-01': {
      chartUrl: '/pages/groessentabelle-jersey',
      chart: HERREN_CHEST,
      measure: 'chest',
      hatDamen: false
    },
    'challventure-bib-shorts-founding-drop-01': {
      chartUrl: '/pages/groessentabelle-bib',
      chart: HERREN_WAIST,
      measure: 'waist',
      hatDamen: true
    }
  };

  var conf = null;
  Object.keys(PRODUCTS).forEach(function (h) {
    if (window.location.pathname.indexOf('/products/' + h) !== -1) conf = PRODUCTS[h];
  });
  if (!conf) return;

  var LIME = '#CDE92D';
  var INK = '#10141a';
  var IST_TAILLE = conf.measure === 'waist';
  var SUB_FORM = IST_TAILLE
    ? 'Zwei Angaben reichen \u2013 wir sch\u00e4tzen deine Taille und empfehlen dir die passende Gr\u00f6\u00dfe.'
    : 'Zwei Angaben reichen \u2013 wir sch\u00e4tzen deinen Brustumfang und empfehlen dir die passende Gr\u00f6\u00dfe.';

  function hideThemeChartLink() {
    var els = document.querySelectorAll('a, button, span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.id === 'cv-sf-trigger' || (el.closest && (el.closest('#cv-sf-overlay') || el.closest('#cv-sf-trigger') || el.closest('#cv-kit-upsell')))) continue;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt !== 'gr\u00f6\u00dfentabelle') continue;
      if (!el.closest('form[action*="/cart/add"], variant-picker, [data-product-form], .product-single, .product')) continue;
      var target = el.closest('a, button') || el;
      target.style.display = 'none';
    }
  }

  function isDamenSelected() {
    if (!conf.hatDamen) return false;
    var els = document.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if ((el.value || '').trim().toLowerCase() !== 'damen') continue;
      if (el.closest('#cv-kit-upsell') || el.closest('#cv-sf-overlay')) continue;
      if (el.closest('form[action*="/cart/add"], variant-picker, [data-product-form], .product-single, .product')) {
        return true;
      }
    }
    return false;
  }

  // Brustumfang-Schaetzung Herren, kalibriert auf Basti: 184 cm / 80 kg -> ~96.5 -> M.
  // Taille = Brust - 13 (KEIN zusaetzlicher BMI-Term – der zaehlte das Gewicht doppelt).
  function estimate(h, w, age) {
    var chest = 0.6 * w + 0.2 * h + 11.7;
    if (age && age >= 45) chest -= 1;
    if (IST_TAILLE) return chest - 13;
    return chest;
  }

  function pick(chart, value, fit) {
    var v = value + (fit === 'regular' ? 1.0 : 0);
    var last = chart.length - 1;
    if (v <= chart[0][0]) return { i: 0, edge: 'low', v: v };
    if (v >= chart[last][1]) return { i: last, edge: 'high', v: v };
    for (var i = 0; i <= last; i++) {
      if (v <= chart[i][1]) {
        if (i < last && (v >= chart[i + 1][0] || chart[i][1] - v < 1)) {
          return { i: (fit === 'regular' ? i + 1 : i), between: [i, i + 1], v: v };
        }
        return { i: i, v: v };
      }
    }
    return { i: last, v: v };
  }

  function inProductScope(el) {
    if (el.closest('#cv-kit-upsell') || el.closest('#cv-sf-overlay')) return false;
    return !!el.closest('form[action*="/cart/add"], variant-picker, [data-product-form], .product-single, .product');
  }

  function applySize(size) {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if ((r.value || '').trim().toUpperCase() !== size) continue;
      if (!inProductScope(r)) continue;
      if (r.disabled) return false;
      r.click();
      r.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var selects = document.querySelectorAll('variant-picker select, form[action*="/cart/add"] select, [data-product-form] select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      if (s.name === 'id' || !inProductScope(s)) continue;
      for (var k = 0; k < s.options.length; k++) {
        var o = s.options[k];
        if ((o.value || '').trim().toUpperCase() !== size) continue;
        if (o.disabled) return false;
        s.value = o.value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  var overlay = null;
  var lastVals = { h: '', w: '', a: '', fit: 'race' };

  function inputStyle() {
    return 'width:100%;box-sizing:border-box;border:1.5px solid #d8d8d3;background:#fff;color:' + INK + ';border-radius:10px;padding:11px 13px;font-size:16px;font-family:inherit;margin-top:5px;outline:none;';
  }

  function buildModal() {
    overlay = document.createElement('div');
    overlay.id = 'cv-sf-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99998;background:rgba(16,20,26,.55);display:none;align-items:center;justify-content:center;padding:16px;';
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });

    var card = document.createElement('div');
    card.style.cssText = 'position:relative;background:#fff;border-radius:14px;max-width:410px;width:100%;padding:26px 24px 22px;font-family:inherit;max-height:92vh;overflow:auto;-webkit-overflow-scrolling:touch;box-shadow:0 18px 60px rgba(16,20,26,.3);';

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Schlie\u00dfen');
    close.innerHTML = '&times;';
    close.style.cssText = 'position:absolute;top:10px;right:12px;background:none;border:none;font-size:26px;line-height:1;color:#8f98a1;cursor:pointer;padding:6px;font-family:inherit;';
    close.addEventListener('click', closeModal);
    card.appendChild(close);

    var eyebrow = document.createElement('div');
    eyebrow.textContent = 'Size Finder';
    eyebrow.style.cssText = 'font-size:11.5px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#6b7280;';
    card.appendChild(eyebrow);

    var h3 = document.createElement('div');
    h3.textContent = 'Finde deine Gr\u00f6\u00dfe';
    h3.style.cssText = 'font-size:21px;font-weight:800;color:' + INK + ';margin-top:3px;';
    card.appendChild(h3);

    var sub = document.createElement('div');
    sub.textContent = SUB_FORM;
    sub.style.cssText = 'font-size:13px;color:#8f98a1;margin:4px 0 14px;line-height:1.5;';
    card.appendChild(sub);

    // Hinweis-Ansicht fuer den Damen-Schnitt (keine automatische Empfehlung)
    var damenView = document.createElement('div');
    damenView.id = 'cv-sf-damen';
    damenView.style.display = 'none';
    var dNote = document.createElement('div');
    dNote.style.cssText = 'font-size:14px;color:' + INK + ';background:rgba(205,233,45,.22);border-radius:10px;padding:14px 16px;margin-top:4px;line-height:1.6;';
    dNote.innerHTML = 'F\u00fcr den <strong>Damen-Schnitt</strong> geben wir aktuell keine automatische Gr\u00f6\u00dfenempfehlung ab \u2013 wir wollen dir lieber gar keinen Wert nennen als einen ungenauen.';
    damenView.appendChild(dNote);
    var dText = document.createElement('div');
    dText.style.cssText = 'font-size:13.5px;color:#5c636b;margin-top:12px;line-height:1.6;';
    dText.innerHTML = (IST_TAILLE
      ? 'Miss deine Taille an der schmalsten Stelle und vergleiche sie mit unserer Ma\u00dftabelle.'
      : 'Miss deinen Brustumfang an der breitesten Stelle und vergleiche ihn mit unserer Ma\u00dftabelle.')
      + ' Unsicher? Schreib uns an <a href="mailto:info@challventure.de" style="color:#7D9700;">info@challventure.de</a> \u2013 wir helfen dir bei der Auswahl.';
    damenView.appendChild(dText);
    var dLink = document.createElement('a');
    dLink.href = conf.chartUrl;
    dLink.target = '_blank';
    dLink.textContent = 'Gr\u00f6\u00dfentabelle ansehen';
    dLink.style.cssText = 'display:block;text-align:center;margin-top:16px;background:' + LIME + ';color:' + INK + ';border-radius:999px;padding:13px;font-size:14.5px;font-weight:800;text-decoration:none;';
    damenView.appendChild(dLink);
    var dHint = document.createElement('div');
    dHint.textContent = 'Passt die Gr\u00f6\u00dfe doch nicht? Wir tauschen kostenlos.';
    dHint.style.cssText = 'text-align:center;font-size:12px;color:#8f98a1;margin-top:12px;';
    damenView.appendChild(dHint);
    card.appendChild(damenView);

    var form = document.createElement('div');
    form.id = 'cv-sf-form';

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:10px;flex-wrap:wrap;';
    var l1 = document.createElement('label');
    l1.style.cssText = 'flex:1 1 130px;font-size:12.5px;font-weight:700;color:' + INK + ';';
    l1.innerHTML = 'K\u00f6rpergr\u00f6\u00dfe (cm)';
    var inH = document.createElement('input');
    inH.type = 'number'; inH.inputMode = 'numeric'; inH.placeholder = 'z. B. 180'; inH.min = 140; inH.max = 215;
    inH.style.cssText = inputStyle();
    l1.appendChild(inH);
    var l2 = document.createElement('label');
    l2.style.cssText = 'flex:1 1 130px;font-size:12.5px;font-weight:700;color:' + INK + ';';
    l2.innerHTML = 'Gewicht (kg)';
    var inW = document.createElement('input');
    inW.type = 'number'; inW.inputMode = 'numeric'; inW.placeholder = 'z. B. 75'; inW.min = 40; inW.max = 150;
    inW.style.cssText = inputStyle();
    l2.appendChild(inW);
    row.appendChild(l1); row.appendChild(l2);
    form.appendChild(row);

    var l3 = document.createElement('label');
    l3.style.cssText = 'display:block;font-size:12.5px;font-weight:700;color:' + INK + ';margin-top:12px;';
    l3.innerHTML = 'Alter <span style="font-weight:500;color:#8f98a1">(optional)</span>';
    var inA = document.createElement('input');
    inA.type = 'number'; inA.inputMode = 'numeric'; inA.placeholder = 'z. B. 30'; inA.min = 14; inA.max = 99;
    inA.style.cssText = inputStyle();
    l3.appendChild(inA);
    form.appendChild(l3);

    var fitLabel = document.createElement('div');
    fitLabel.textContent = 'Wie soll es sitzen?';
    fitLabel.style.cssText = 'font-size:12.5px;font-weight:700;color:' + INK + ';margin-top:14px;';
    form.appendChild(fitLabel);

    var pills = document.createElement('div');
    pills.style.cssText = 'display:flex;gap:8px;margin-top:7px;flex-wrap:wrap;';
    var fitVal = { v: 'race' };
    function makePill(value, text) {
      var p = document.createElement('button');
      p.type = 'button';
      p.dataset.val = value;
      p.textContent = text;
      p.style.cssText = 'flex:1 1 auto;border:1.5px solid #d8d8d3;background:#fff;color:' + INK + ';border-radius:999px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;';
      p.addEventListener('click', function () {
        fitVal.v = value;
        Array.prototype.forEach.call(pills.children, function (c) {
          var on = c.dataset.val === value;
          c.style.borderColor = on ? LIME : '#d8d8d3';
          c.style.background = on ? 'rgba(205,233,45,.18)' : '#fff';
        });
      });
      return p;
    }
    pills.appendChild(makePill('race', 'Eng & aero (Race-Fit)'));
    pills.appendChild(makePill('regular', 'Etwas lockerer'));
    form.appendChild(pills);
    setTimeout(function () { pills.children[0].click(); }, 0);

    var err = document.createElement('div');
    err.style.cssText = 'display:none;font-size:12.5px;color:#c0392b;margin-top:10px;line-height:1.4;';
    form.appendChild(err);

    var go = document.createElement('button');
    go.type = 'button';
    go.textContent = 'Gr\u00f6\u00dfe berechnen';
    go.style.cssText = 'width:100%;margin-top:15px;background:' + LIME + ';color:' + INK + ';border:none;border-radius:999px;padding:13px;font-size:14.5px;font-weight:800;cursor:pointer;font-family:inherit;';
    go.addEventListener('click', function () {
      var h = parseFloat(inH.value);
      var w = parseFloat(inW.value);
      var a = parseFloat(inA.value);
      if (!h || h < 140 || h > 215 || !w || w < 40 || w > 150) {
        err.textContent = 'Bitte gib K\u00f6rpergr\u00f6\u00dfe (140\u2013215 cm) und Gewicht (40\u2013150 kg) an.';
        err.style.display = 'block';
        return;
      }
      err.style.display = 'none';
      lastVals = { h: inH.value, w: inW.value, a: inA.value, fit: fitVal.v };
      showResult(h, w, (a && a >= 14 && a <= 99) ? a : null, fitVal.v);
    });
    form.appendChild(go);

    var chartLink = document.createElement('a');
    chartLink.href = conf.chartUrl;
    chartLink.target = '_blank';
    chartLink.textContent = 'Oder: Gr\u00f6\u00dfentabelle ansehen';
    chartLink.style.cssText = 'display:block;text-align:center;margin-top:12px;font-size:12.5px;color:#8f98a1;text-decoration:underline;';
    form.appendChild(chartLink);

    card.appendChild(form);

    var result = document.createElement('div');
    result.id = 'cv-sf-result';
    result.style.display = 'none';
    card.appendChild(result);

    overlay.appendChild(card);
    document.body.appendChild(overlay);

    overlay._form = form;
    overlay._result = result;
    overlay._sub = sub;
    overlay._damen = damenView;
    overlay._inputs = { h: inH, w: inW, a: inA };
  }

  function showResult(h, w, age, fit) {
    var value = estimate(h, w, age);
    var r = pick(conf.chart, value, fit);
    var size = HERREN_SIZES[r.i];
    var range = conf.chart[r.i];

    var res = overlay._result;
    res.innerHTML = '';
    overlay._form.style.display = 'none';
    res.style.display = 'block';

    var badge = document.createElement('div');
    badge.style.cssText = 'width:68px;height:68px;border-radius:50%;background:' + LIME + ';color:' + INK + ';display:flex;align-items:center;justify-content:center;font-size:' + (size.length > 2 ? '20px' : '26px') + ';font-weight:800;margin:6px auto 10px;';
    badge.textContent = size;
    res.appendChild(badge);

    var head = document.createElement('div');
    head.textContent = 'Unsere Empfehlung: Gr\u00f6\u00dfe ' + size;
    head.style.cssText = 'text-align:center;font-size:18px;font-weight:800;color:' + INK + ';';
    res.appendChild(head);

    var detail = document.createElement('div');
    detail.textContent = (IST_TAILLE ? 'Gesch\u00e4tzte Taille: ca. ' : 'Gesch\u00e4tzter Brustumfang: ca. ') + Math.round(value) + ' cm \u2192 Gr\u00f6\u00dfe ' + size + ' (' + range[0] + '\u2013' + range[1] + ' cm)';
    detail.style.cssText = 'text-align:center;font-size:13px;color:#8f98a1;margin-top:6px;line-height:1.5;';
    res.appendChild(detail);

    if (IST_TAILLE) {
      var komp = document.createElement('div');
      komp.textContent = 'Bib Shorts sitzen kompressiv und eng am K\u00f6rper \u2013 das ist so gewollt.';
      komp.style.cssText = 'text-align:center;font-size:12px;color:#8f98a1;margin-top:4px;line-height:1.5;';
      res.appendChild(komp);
    }

    var noteText = '';
    if (r.between) {
      var lo = HERREN_SIZES[r.between[0]], hi = HERREN_SIZES[r.between[1]];
      noteText = fit === 'regular'
        ? 'Du liegst zwischen ' + lo + ' und ' + hi + ' \u2013 f\u00fcr etwas mehr Komfort empfehlen wir ' + hi + '.'
        : 'Du liegst zwischen ' + lo + ' und ' + hi + ' \u2013 f\u00fcr den engen Race-Fit empfehlen wir ' + lo + '.';
    } else if (r.edge === 'low') {
      noteText = 'Du liegst am unteren Rand unserer Tabelle \u2013 ' + size + ' ist unsere kleinste Gr\u00f6\u00dfe.';
    } else if (r.edge === 'high') {
      noteText = 'Du liegst am oberen Rand unserer Tabelle \u2013 bei Fragen hilft unser Team unter info@challventure.de.';
    }
    if (noteText) {
      var note = document.createElement('div');
      note.textContent = noteText;
      note.style.cssText = 'font-size:12.5px;color:' + INK + ';background:rgba(205,233,45,.22);border-radius:10px;padding:10px 12px;margin-top:12px;line-height:1.5;';
      res.appendChild(note);
    }

    var basti = document.createElement('div');
    basti.textContent = 'Zum Vergleich: Basti (1,84 m / 80 kg) tr\u00e4gt Gr\u00f6\u00dfe M.';
    basti.style.cssText = 'text-align:center;font-size:12px;color:#8f98a1;margin-top:12px;';
    res.appendChild(basti);

    var hinweis = document.createElement('div');
    hinweis.textContent = 'Passt die Gr\u00f6\u00dfe doch nicht? Wir tauschen kostenlos.';
    hinweis.style.cssText = 'text-align:center;font-size:12px;color:#8f98a1;margin-top:6px;';
    res.appendChild(hinweis);

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.textContent = 'Gr\u00f6\u00dfe ' + size + ' \u00fcbernehmen';
    apply.style.cssText = 'width:100%;margin-top:14px;background:' + LIME + ';color:' + INK + ';border:none;border-radius:999px;padding:13px;font-size:14.5px;font-weight:800;cursor:pointer;font-family:inherit;';
    apply.addEventListener('click', function () {
      var ok = applySize(size);
      if (ok) {
        apply.textContent = '\u2713 Gr\u00f6\u00dfe \u00fcbernommen';
        setTimeout(closeModal, 650);
      } else {
        apply.textContent = 'Gr\u00f6\u00dfe ' + size + ' aktuell nicht verf\u00fcgbar';
        apply.style.background = '#eeeeea';
        apply.style.cursor = 'default';
      }
    });
    res.appendChild(apply);

    var back = document.createElement('button');
    back.type = 'button';
    back.textContent = 'Angaben anpassen';
    back.style.cssText = 'display:block;width:100%;margin-top:10px;background:none;border:none;font-size:12.5px;color:#8f98a1;text-decoration:underline;cursor:pointer;font-family:inherit;';
    back.addEventListener('click', function () {
      res.style.display = 'none';
      overlay._form.style.display = 'block';
    });
    res.appendChild(back);
  }

  function openModal() {
    if (!overlay) buildModal();
    overlay._result.style.display = 'none';
    if (isDamenSelected()) {
      overlay._form.style.display = 'none';
      overlay._damen.style.display = 'block';
      overlay._sub.textContent = 'F\u00fcr den Damen-Schnitt findest du die Ma\u00dfe in der Gr\u00f6\u00dfentabelle.';
    } else {
      overlay._damen.style.display = 'none';
      overlay._form.style.display = 'block';
      overlay._sub.textContent = SUB_FORM;
      if (lastVals.h) overlay._inputs.h.value = lastVals.h;
      if (lastVals.w) overlay._inputs.w.value = lastVals.w;
      if (lastVals.a) overlay._inputs.a.value = lastVals.a;
    }
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (overlay) {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  function findSizeAnchor() {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var v = (r.value || '').trim().toUpperCase();
      if (SIZES.indexOf(v) === -1) continue;
      if (!inProductScope(r)) continue;
      return r.closest('fieldset') || r.closest('[class*="option"]') || r.parentElement;
    }
    var selects = document.querySelectorAll('variant-picker select, form[action*="/cart/add"] select, [data-product-form] select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      if (s.name === 'id' || !inProductScope(s)) continue;
      var hasSize = Array.prototype.some.call(s.options, function (o) {
        return SIZES.indexOf((o.value || '').trim().toUpperCase()) !== -1;
      });
      if (hasSize) return s.closest('fieldset') || s.closest('[class*="option"]') || s.parentElement;
    }
    return null;
  }

  function buildTrigger() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'cv-sf-trigger';
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="' + INK + '" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 15l13-13 7 7-13 13z"/><path d="M7.5 9.5l1.8 1.8M10.5 6.5l1.8 1.8M13.5 3.5l1.8 1.8"/></svg><span>Finde deine Gr\u00f6\u00dfe</span><span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:' + LIME + ';"></span>';
    btn.style.cssText = 'display:inline-flex;align-items:center;gap:8px;margin:12px 0 4px;background:#fff;border:1.5px solid ' + INK + ';border-radius:999px;padding:10px 16px;cursor:pointer;font-family:inherit;font-size:13.5px;font-weight:700;color:' + INK + ';min-height:42px;touch-action:manipulation;box-shadow:0 1px 4px rgba(16,20,26,.08);transition:background .15s;';
    btn.addEventListener('mouseenter', function () { btn.style.background = 'rgba(205,233,45,.18)'; });
    btn.addEventListener('mouseleave', function () { btn.style.background = '#fff'; });
    btn.addEventListener('click', openModal);
    return btn;
  }

  function tryInsert(allowFallback) {
    if (document.getElementById('cv-sf-trigger')) { hideThemeChartLink(); return true; }
    var anchor = findSizeAnchor();
    if (anchor) {
      anchor.insertAdjacentElement('afterend', buildTrigger());
      hideThemeChartLink();
      return true;
    }
    if (allowFallback) {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.insertAdjacentElement('beforebegin', buildTrigger());
        hideThemeChartLink();
        return true;
      }
    }
    return false;
  }

  function boot() {
    if (tryInsert(false)) return;
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      if (tryInsert(false)) { done = true; obs.disconnect(); }
    });
    try {
      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    setTimeout(function () {
      if (done) return;
      done = true;
      obs.disconnect();
      tryInsert(true);
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { setTimeout(function () { tryInsert(true); }, 400); });
  window.addEventListener('resize', function () { setTimeout(function () { tryInsert(false); }, 200); });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && (e.target.closest('#cv-sf-overlay') || e.target.closest('#cv-kit-upsell'))) return;
    setTimeout(function () { tryInsert(false); }, 250);
    setTimeout(function () { tryInsert(true); }, 900);
  });
})();
